import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIxPrnsrvcListStatus: 'idle',
    loadIxPrnsrvcListError: undefined as any,
    loadIxPrnsrvcListLastArgs: undefined as any,
    loadIxPrnsrvcStatus: 'idle',
    loadIxPrnsrvcError: undefined as any,
    saveIxPrnsrvcStatus: 'idle',
    saveIxPrnsrvcError: undefined as any,
    deleteIxPrnsrvcStatus: 'idle',
    deleteIxPrnsrvcError: undefined as any,

    ixPrnsrvcList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIxPrnsrvcList = createAsyncThunk('ixPrnsrvcSlice/loadIxPrnsrvcList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ixPrnsrvcSlice.loadIxPrnsrvcListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvc/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIxPrnsrvcListStatus } = getState().ixPrnsrvcSlice
        return loadIxPrnsrvcListStatus !== 'pending'
    }
})

export const loadIxPrnsrvc = createAsyncThunk('ixPrnsrvcSlice/loadIxPrnsrvc', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvc/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIxPrnsrvcStatus } = getState().ixPrnsrvcSlice
        return loadIxPrnsrvcStatus !== 'pending'
    }
})

export const saveIxPrnsrvc = createAsyncThunk('ixPrnsrvcSlice/saveIxPrnsrvc', async ({ ixPrnsrvc }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ixPrnsrvc?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ixprnsrvc/${ ixPrnsrvc?.HDR_ID }/`,
            prepareData(ixPrnsrvc),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ixprnsrvc/`,
            prepareData(ixPrnsrvc),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIxPrnsrvcStatus } = getState().ixPrnsrvcSlice
        return saveIxPrnsrvcStatus !== 'pending'
    }
})

export const deleteIxPrnsrvc = createAsyncThunk('ixPrnsrvcSlice/deleteIxPrnsrvc', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ixprnsrvc/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIxPrnsrvcStatus } = getState().ixPrnsrvcSlice
        return deleteIxPrnsrvcStatus !== 'pending'
    }
})

const IxPrnsrvcSlice = createSlice({
    name: 'ixPrnsrvcSlice',
    initialState,
    reducers: {
        resetloadIxPrnsrvcListError: (state) => {
            state.loadIxPrnsrvcListError = undefined
        },
        resetloadIxPrnsrvc: (state) => {
            state.formItem = undefined
            state.loadIxPrnsrvcError = undefined
        },
        resetloadIxPrnsrvcError: (state) => {
            state.loadIxPrnsrvcError = undefined
        },
        resetsaveIxPrnsrvc: (state) => {
            state.formItem = undefined
            state.saveIxPrnsrvcError = undefined
        },
        resetsaveIxPrnsrvcError: (state) => {
            state.saveIxPrnsrvcError = undefined
        },
        resetdeleteIxPrnsrvcError: (state) => {
            state.deleteIxPrnsrvcError = undefined
        },
        removeFromIxPrnsrvcListById: (state, action) => {
            state.ixPrnsrvcList = state.ixPrnsrvcList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIxPrnsrvcListByIds: (state, action) => {
            state.ixPrnsrvcList = state.ixPrnsrvcList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ixPrnsrvcList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIxPrnsrvcListStatus = 'preloaded'
            state.loadIxPrnsrvcListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ixPrnsrvcList = []
            state.loadIxPrnsrvcListStatus = 'idle'
            state.loadIxPrnsrvcListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIxPrnsrvcList.pending, (state) => {
            state.loadIxPrnsrvcListStatus = 'pending'
            state.loadIxPrnsrvcListError = undefined
        })
        builder.addCase(loadIxPrnsrvcList.fulfilled, (state, action) => {
            state.loadIxPrnsrvcListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIxPrnsrvcListLastArgs = action.payload.args

            {
                state.ixPrnsrvcList = action.payload.data

            }
        })
        builder.addCase(loadIxPrnsrvcList.rejected, (state, action) => {
            state.loadIxPrnsrvcListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIxPrnsrvcListError = action.error.message
            } else {
                state.loadIxPrnsrvcListError = action.payload
            }
        })

        builder.addCase(loadIxPrnsrvc.pending, (state) => {
            state.loadIxPrnsrvcStatus = 'pending'
            state.loadIxPrnsrvcError = undefined
        })
        builder.addCase(loadIxPrnsrvc.fulfilled, (state, action) => {
            state.loadIxPrnsrvcStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ixPrnsrvcList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ixPrnsrvcList.push(newItem) }
                else { state.ixPrnsrvcList[i] = { ...state.ixPrnsrvcList[i], ...newItem } }
            }
        })
        builder.addCase(loadIxPrnsrvc.rejected, (state, action) => {
            state.loadIxPrnsrvcStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIxPrnsrvcError = action.error.message
            } else {
                state.loadIxPrnsrvcError = action.payload
            }
        })

        builder.addCase(saveIxPrnsrvc.pending, (state) => {
            state.saveIxPrnsrvcStatus = 'pending'
            state.saveIxPrnsrvcError = undefined
        })
        builder.addCase(saveIxPrnsrvc.fulfilled, (state, action) => {
            state.saveIxPrnsrvcStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ixPrnsrvcList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ixPrnsrvcList.push(newItem) }
                else { state.ixPrnsrvcList[i] = { ...state.ixPrnsrvcList[i], ...newItem } }
            }
        })
        builder.addCase(saveIxPrnsrvc.rejected, (state, action) => {
            state.saveIxPrnsrvcStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIxPrnsrvcError = action.error.message
            } else {
                state.saveIxPrnsrvcError = action.payload
            }
        })

        builder.addCase(deleteIxPrnsrvc.pending, (state) => {
            state.deleteIxPrnsrvcStatus = 'pending'
            state.deleteIxPrnsrvcError = undefined
        })
        builder.addCase(deleteIxPrnsrvc.fulfilled, (state, action) => {
            state.deleteIxPrnsrvcStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ixPrnsrvcList = state.ixPrnsrvcList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ixPrnsrvcList = state.ixPrnsrvcList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIxPrnsrvc.rejected, (state, action) => {
            state.deleteIxPrnsrvcStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIxPrnsrvcError = action.error.message
            } else {
                state.deleteIxPrnsrvcError = action.payload
            }
        })

    }
})

export const {
    resetloadIxPrnsrvcListError,
    resetloadIxPrnsrvc,
    resetloadIxPrnsrvcError,
    resetsaveIxPrnsrvc,
    resetsaveIxPrnsrvcError,
    resetdeleteIxPrnsrvcError,
    removeFromIxPrnsrvcListById,
    removeFromIxPrnsrvcListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = IxPrnsrvcSlice.actions
export default IxPrnsrvcSlice.reducer
